import React from 'react'

import Tooltip, { tooltipClasses } from '@mui/material/Tooltip'
import { styled } from '@mui/material/styles'

const LightTooltip = styled(({ className, ...props }) => <Tooltip {...props} classes={{ popper: className }} />)(
  ({ theme, ...props }) => ({
    width: props.width ? props.width : '90px',
    [`& .${tooltipClasses.tooltip}`]: {
      backgroundColor: theme.palette.color.blueLight2,
      color: theme.palette.text.white,
      textAlign: 'center',
      fontSize: '12px',
      lineHeight: '16px',
      marginInline: 'auto'
    },
    [`& .${tooltipClasses.arrow}:before`]: {
      backgroundColor: theme.palette.color.blueLight2,
      marginInline: 'auto'
    },
  }),
)

const ButtonTooltip = ({ title, children, ...rest }) => {
  return (
    <>
      {title && (
        <LightTooltip title={title} {...rest}>
          {children}
        </LightTooltip>
      )}
    </>
  )
}

export default ButtonTooltip
